<template>
  <section id="homeAddress">
    <div class="container">
      <div class="header">
        <h5>{{ stateName }}</h5>
        <CancelButton></CancelButton>
      </div>
      <form action="#" autocomplete="off">
        <h5>Great! Hi {{ person }} <br />Just a few more items...</h5>
        <div class="columns">
          <div class="column is-two-third">
            <div class="control">
              <label for="streetAddress">
                Unit Number &amp; Complex Name:<br />
                <p class="ifApplic">If applicable</p>
              </label>
              <input
                class="input"
                type="text"
                id="unitNumber"
                v-model="unitNumber"
                v-on:keyup.enter="focusOut($event)"
              />
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-two-third">
            <div class="control streetAddress">
              <label for="streetAddress">
                Street Address
                <span>*</span>
                <p class="ifApplic">
                  Please start typing &amp; select from the drop down
                </p>
              </label>
              <input
                v-model="selectedAddress"
                v-validate="'required'"
                id="streetAddress"
                class="input"
                ref="autocomplete"
                type="text"
                placeholder="We want to find your nearest store"
                required
                v-on:keyup.enter="focusOut($event)"
              />
            </div>
          </div>
          <div class="column is-two-third">
            <div class="control">
              <label for="city">
                City
                <span>*</span>
                <p class="ifApplic">&nbsp;</p>
              </label>
              <input
                v-model="city"
                v-validate="'required'"
                id="city"
                class="input"
                type="text"
                placeholder="We want to find your nearest store"
                required
                v-on:keyup.enter="focusOut($event)"
              />
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-two-third">
            <div class="control">
              <label for="province">
                Province
                <span>*</span>
                <p class="ifApplic">&nbsp;</p>
              </label>
              <input
                v-model="province"
                v-validate="'required'"
                id="province"
                class="input"
                type="text"
                placeholder="We want to find your nearest store"
                required
                v-on:keyup.enter="focusOut($event)"
              />
            </div>
          </div>
          <div class="column is-two-third">
            <div class="control">
              <label for="postalCode">
                Postal Code
                <span>*</span>
                <p class="ifApplic">&nbsp;</p>
              </label>
              <input
                v-model="postalCode"
                v-validate="'required'"
                id="postalCode"
                class="input"
                type="text"
                placeholder="We want to find your nearest store"
                required
                v-on:keyup.enter="focusOut($event)"
              />
            </div>
          </div>
        </div>
        <div v-if="this.stateName === 'Home Improver'" class="columns penCol">
          <div class="column is-one-third">
            <div class="question">
              <p>
                Can we send you updates about exclusive benefits and discounts
                via email?
              </p>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="content">
              <div class="titleContainer yesNo">
                <input
                  v-model="promotions"
                  type="radio"
                  id="promotionsYes"
                  value="yes"
                />
                <label for="promotionsYes">Yes Please</label>

                <input
                  v-model="promotions"
                  type="radio"
                  id="promotionsNo"
                  value="no"
                />
                <label for="promotionsNo">No Thanks</label>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="columns">
          <div class="column is-one-third">
            <div class="question m-0">
              <p>Would you like to hear about our great specials and promotions?</p>
              <small>We promise we won't spam you</small>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="content">
              <div class="titleContainer yesNo">
                <input v-model="promotions" type="radio" id="specialsYes" value="yes" />
                <label for="specialsYes">Yes Please</label>

                <input v-model="promotions" type="radio" id="specialsNo" value="no" />
                <label for="specialsNo">No Thanks</label>
              </div>
            </div>
          </div>
        </div> -->
        <div class="columns">
          <div class="column is-two-thirds">
            <div>
              <p>Shaves Paint + Décor is POPI compliant.</p>
            </div>
            <div class="termsAndConditions">
              <div class="checkBox">
                <input
                  v-validate="'required'"
                  v-model="TandC"
                  type="checkbox"
                  name="TandC"
                  id="TandC"
                />
                <span class="checkmark"></span>
              </div>
              <p>
                I agree to the
                <a @click="openTermsAndConditions">terms and conditions</a>
                specified.
              </p>
            </div>
          </div>
        </div>
      </form>

      <div class="actions">
        <button @click="back" class="button is-white">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button
          @click="toContactInfo"
          :disabled="isDisabled"
          class="button is-blue"
        >
          Continue
        </button>
      </div>
    </div>
  </section>
</template>


<script>
import CancelButton from "../../components/actions/CancelButton";
import alertify from "alertifyjs";

export default {
  name: "individualaddress",
  components: {
    CancelButton,
  },
  data() {
    return {
      disabled: true,
      stateName: "",
      unitNumber: "",
      streetAddress: "",
      province: null,
      city: null,
      postalCode: null,
      selectedAddress: null,
      TandC: null,
      // balance: "yes",
      promotions: "yes",
    };
  },
  methods: {
    toContactInfo() {
      this.$validator.validate().then((result) => {
        if (!result) {
          this.loading = false;
          alertify.error("Please check all fields are filled in correctly.");
        } else {
          this.$gtag.event("promotions_newsletter", {
            event_category: "engagement",
            event_label: this.promotions,
            value: ""
          });
          // this.$gtag.event("send_balance", {
          //   event_category: "engagement",
          //   event_label: this.balance,
          //   value: "",
          // });
          if (this.unitNumber != "") {
            this.unitNumber = this.unitNumber + ", ";
          }
          this.$store.commit("SAVE_PERSONAL_ADDRESS", {
            address: this.unitNumber + this.selectedAddress,
            city: this.city,
            province: this.province,
            postalCode: this.postalCode,
            TandC: this.TandC,
            // balanceMail: this.balance,
            promotionMail: this.promotions
          });
          this.$router.push("/loyaltycard");
        }
      });
    },
    back() {
      document.body.classList.add("transitionBack");

      this.$router.go(-1);

      setTimeout(() => {
        document.body.classList.remove("transitionBack");
      }, 1000);
    },
    openTermsAndConditions() {
      document.body.classList.add("showTermsAndConditions");
    },
  },
  created() {
    if (this.$store.state.loyaltyType == "personal") {
      this.stateName = "Home Improver";
    } else {
      this.stateName = "Pensioner";
    }
  },
  mounted() {
    this.autocomplete = new window.google.maps.places.Autocomplete(
      this.$refs.autocomplete,
      {
        types: ["geocode"],
      }
    );
    this.autocomplete.setComponentRestrictions({ country: ["za"] });

    this.autocomplete.addListener("place_changed", () => {
      let place = this.autocomplete.getPlace();
      if (
        place.address_components !== undefined &&
        place.address_components.length > 0
      ) {
        // selected option
        this.disabled = false;
        let newstreetAddress = "";
        let city = "";
        let province = "";
        let postalCode = "";

        place.address_components.forEach((component) => {
          if (
            component.types.includes("street_number") ||
            component.types.includes("route") ||
            component.types.includes("sublocality_level_1")
          ) {
            console.log(component.long_name);
            newstreetAddress += component.long_name + " ";
            // streetAddress = "here";
          }
          if (component.types.includes("locality")) {
            city = component.long_name;
          }
          if (component.types.includes("administrative_area_level_1")) {
            province = component.long_name;
          }
          if (component.types.includes("postal_code")) {
            postalCode = component.long_name;
          }
        });

        this.selectedAddress = "";
        setTimeout(() => {
          this.selectedAddress = newstreetAddress;
          this.city = city;
          this.province = province;
          this.postalCode = postalCode;
        }, 100);
      } else {
        // just typed and hit enter (no option selected)
        this.disabled = true;
        alertify.error("Please select location from the drop down menu.");
      }
    });
    if (this.$store.state.personal.address.promotionMail != undefined) {
      this.selectedAddress = this.$store.state.personal.address.address;
      this.TandC = this.$store.state.personal.address.TandC;
      // this.balance = this.$store.state.personal.address.balanceMail;
      this.promotions = this.$store.state.personal.address.promotionMail;
      console.log("setting values");
    }
  },
  computed: {
    person() {
      return this.$store.state.personal.info.firstName;
    },
    isDisabled: function () {
      return this.disabled;
    },
  },
};
</script>